<template>
    <div class="block">
        <!-- 表格分页-->
    <el-table element-loading-text="拼命加载中" ref="tradeTable" :data="tableData.list" border style="" :row-key='getRowKeys'>
                        <el-table-column type="expand">
                            <template slot-scope="props">
                                <el-table element-loading-text="拼命加载中" ref="tradeTable" :data="tableData.list[props.$index].orderPro" border style="">
                                    <el-table-column prop="productName" label="商品名称" > </el-table-column>
                                    <el-table-column prop="SKU" label="商品SKU" > </el-table-column>
                                    <el-table-column prop="proTotal" label="商品单价" >
                                        <template scope="scope">
                                            <div >￥{{scope.row.proTotal / 100}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="discount" label="优惠金额" >
                                        <template scope="scope">
                                            <div >￥{{scope.row.discount / 100}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="proPayTotal" label="实付金额" >
                                        <template scope="scope">
                                            <div >￥{{scope.row.proPayTotal / 100}}</div>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="proStatus" label="商品状态" >
                                        <template scope="scope">
                                            <div v-if="tableData.list[props.$index].payStatus == 'not'">
                                                <div >待付款</div>
                                            </div>
                                            <div v-else-if="tableData.list[props.$index].payStatus == 'ok'">
                                                <div v-if="tableData.list[props.$index].outStatus == '0' &&  tableData.list[props.$index].refStatus == '0' &&  tableData.list[props.$index].orderStatus == '0'">待取货</div>
                                                <div v-if="tableData.list[props.$index].outStatus == '0' && tableData.list[props.$index].refStatus == '1' && tableData.list[props.$index].expStatus != '2'">取消出货</div>
                                                <div v-if="tableData.list[props.$index].outStatus == '0' && tableData.list[props.$index].refStatus == '4' && tableData.list[props.$index].expStatus != '2'">取消出货</div>
                                                <div v-if="tableData.list[props.$index].outStatus == '0' && tableData.list[props.$index].payStatus == 'ok' && tableData.list[props.$index].expStatus == '2'  ">创建提货码失败</div>
                                                <div v-if="scope.row.proStatus=='出货成功'">出货成功</div>
                                                <div v-if="scope.row.proStatus=='出货失败'">出货失败</div>
                                            </div>
                                            <div v-else="tableData.list[props.$index].payStatus == 'err'">
                                                <div >支付异常</div>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </template>
                        </el-table-column>

                        <el-table-column prop="orderId" label="订单编号" > </el-table-column>
                        <el-table-column prop="kioskNo" label="机器编号" > </el-table-column>
                        <el-table-column label="数量" >
                            <template scope="scope">
                                <div v-if="scope.row.outStatus == '2'" style="color: red">
                                    {{scope.row.shipmentNum}}/{{scope.row.orderPro.length}}
                                </div>
                                <div v-else>
                                    {{scope.row.shipmentNum}}/{{scope.row.orderPro.length}}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="timeStart" label="订单时间" :formatter="startformatter">  </el-table-column>
                        <el-table-column prop="orderStatus" label="订单状态" >
                            <template scope="scope">
                                <div v-if="scope.row.payStatus=='not' && scope.row.orderStatus == '0'">
                                    待付款
                                </div>
                                <div v-else>
                                    <div  v-if="scope.row.refStatus == '3'" >
                                        退款中
                                    </div>
                                    <div v-else-if="scope.row.outStatus == '2' && scope.row.refStatus=='0' || scope.row.refStatus=='2' && scope.row.orderStatus == '2'">
                                        待处理
                                    </div>
                                    <div v-else-if="scope.row.outStatus == '0' && scope.row.refStatus == '0' && scope.row.payStatus=='ok' && scope.row.orderStatus == '0'">
                                        待取货
                                    </div>
                                    <div v-else-if="scope.row.refStatus == '1' && scope.row.outStatus == '2' && scope.row.orderStatus == '1' ">
                                        已完成
                                    </div>
                                    <div v-else-if="scope.row.orderStatus == '1' && scope.row.refStatus == '0' && scope.row.outStatus == '1'">
                                        已完成
                                    </div>
                                    <div  v-if="scope.row.refStatus == '4'" >
                                        申请退款
                                    </div>
                                    <div v-else-if="scope.row.orderStatus == '3'">
                                        已关闭
                                    </div>

                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="payMode" label="支付方式" > </el-table-column>
                        <el-table-column prop="payTotal" label="实付金额" >
                            <template scope="scope">
                                <div >￥{{scope.row.payTotal / 100}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="updateTime" label="修改时间" :formatter="updateformatter">  </el-table-column>
                        <el-table-column label="操作" width="155px">
                            <template scope="scope" >
                                <el-button type="danger"  size="small" :disabled="scope.row.payStatus !='ok'" @click="refProductOpen(scope.row)" >退款</el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <div class="block">
                        <el-pagination
                                @current-change="handleCurrentChange"
                                @size-chahange="handleSizeChange"
                                :current-page="currentpage"
                                :page-count="pagesCount"
                                :page-sizes="pagesizes"
                                :page-size="pagesize"
                                :total="pagesCount"
                                layout=" total, prev, pager, next, jumper"
                        >
                        </el-pagination>
                    </div>
    </div>
</template>
<script>
    /*import  Bootpage from "../page/Bootpage.vue"*/
    import moment  from 'moment'
    import ElDialog from "../../../../node_modules/element-ui/packages/dialog/src/component.vue";
    export  default{
        props: {
            orderId: String,
            orderstatus: String,
            endTime: Number,
            startTime: Number,
            kioskNo: String,
        },
        components: {ElDialog},
        data(){
            return {
                getRowKeys (row) {
                    return row.orderId
                },
                //页眉设置参数
                currentpage: 1,//当前页数默认是1
                pagesCount: 0, //总数默认0
                pagesizes: [10, 20, 30],//条数列
                pagesize: 10,//行数
                activeNum: 0, //默认起始行数
                endNum: 10,//默认结束行数
                tableData: [], // 分页组件传回的分页后数据
                /*弹窗选择*/
                //参数设置
                url: this.productURL+"/vueFeign/adminOrder", // 分页查询请求路径
                name:'',
                loading:false,
                isorno:false,
            }

        },
        created(){
            this.getData(this.activeNum);
        },
        methods: {
            handleSizeChange(val){
                console.log(`每页 ${val} 条`);
                this.pagesize=val
                this.activeNum=(val*this.currentpage)-val;
                this.endNum=(val*this.currentpage)
                this.getData(this.activeNum);
                //数目变更
            },
            handleCurrentChange(val){
                this.currentpage=val;
                this.activeNum=(this.pagesize*val)-this.pagesize
                this.endNum=(this.pagesize*val)
                this.getData(this.activeNum);
            },
            getData(active){
                if(active == 0){
                    this.currentpage= 1 ;
                }
                //数据请求
                this.loading = true
                var params = {active:active,len:this.pagesize,orderNo:this.orderId,orderstatus:this.orderstatus,tenantId:this.getcookie('storeId'),
                    startTime:parseInt(this.startTime),endTime:parseInt(this.endTime),kioskNo:this.kioskNo};
                //异步请求
                this.$http.post(this.url,params)
                    .then(response => {
                        if (response.status === 200) {
                            if(response.body.code=='400'){
                                this.$message({ showClose: true, message: response.body.msg,  type: 'error' });
                            }else{
                                this.pagesCount = response.body.Data.count
                                //this.tableData = response.body.Data.orderlist
                                console.log(this.tableData);
                                this.$set(this.tableData,'list',response.body.Data.orderlist)
                                console.log(this.tableData);
                                this.loading = false;
                            }
                        }
                    },function(response){
                        this.$message({
                            showClose: true,
                            message: '网络异常',
                            type: 'error'

                        });
                    })
                this.fileSpan();
            },
            updateformatter(row, column) {
                console.log()
                var d = new Date(row.updateTime.time)
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },startformatter(row, column) {
                console.log()
                var d = new Date(row.timeStart.time)
                var formatString = formatString || 'YYYY-MM-DD HH:mm:ss';
                return moment(d).format(formatString);
            },
            fileSpan(){
                this.isorno=false;
            },
            refProductOpen(row){
                this.$router.push( {path:"orderRef",query:{orderPro:row.orderPro,orderId:row.orderId,proPayTotal:row.proPayTotal,
                    kioskNo:this.kioskNo,
                    refStatus:row.refStatus,
                    payStatus:row.payStatus,
                    orderNo:this.orderId,
                    datatime:[this.startTime,this.endTime]}});
            },
        }

    }

</script>
<style>
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .customWidth {
        width: 60%;
    }
    .box_relative{
        float: left;
    }
</style>


// WEBPACK FOOTER //
// table.vue?5737f626